[
  {
    "id": "gatorade",
    "name": "GATORADE",
    "title": "",
    "description": "",
    "color": "#3baae3",
    "stats": [
      {
        "value": "+1,400",
        "unit": "%",
        "desc": "Increase in Gatorade.com Site Visits vs. prior period²"
      },
      {
        "value": "+450",
        "unit": "%",
        "desc": "Increase in Gatorade ID Sign-ups vs. prior period"
      },
      { "value": "+8.5", "unit": "PP", "desc": "Increase in brand consideration intent¹" },
      { "value": "+7.5", "unit": "PP", "desc": "Increase in aided brand awareness¹" },
      {
        "value": "+7",
        "unit": "PP",
        "desc": "YoY Gatorade Volume growth vs Other Benchmark Products³"
      },
      {
        "value": "+2",
        "unit": "PP",
        "desc": "Distribution growth of Gatorade products at campaign properties"
      }
    ],
    "detailTitle": "Targeted Messaging Across Channels",
    "detailDesc": "Gatorade tapped into Marriott's first-party targeting and in-room media to engage consumers at key moments throughout their journey. Targeted messaging at each touchpoint ensured Gatorade met travelers' hydration needs every step of the way.",
    "footnotes": "1.Brand lift study conducted only on web; 2. Google Analytics (GA4); 3. PEP Star 2 Reporting"
  },
  {
    "id": "visa",
    "name": "VISA",
    "title": "Real-time relevance, real-world impact",
    "description": "Visa partnered with Marriott Media to drive Visa card usage for international travel.",
    "mainBlockDesc": "To showcase the perks of using Visa abroad, Visa teamed up with  Marriott Media to reach guests through targeted in-room media and  other digital touchpoints.",
    "color": "#3baae3",
    "stats": [
      {
        "value": "+5.9",
        "unit": "PP",
        "desc": "In perception that Visa sets the standard for payment brands¹"
      },
      {
        "value": "+1",
        "unit": "%",
        "desc": "YoY growth in bookings made to destinations featured³"
      },
      {
        "value": "+8.3",
        "unit": "PP",
        "desc": "In perception by travelers that Visa is more trusted²"
      },
      {
        "value": "49",
        "unit": "%",
        "desc": "Of international trips booked by an ad exposed guests"
      }
    ],
    "detailTitle": "Connected with travelers where it counts",
    "detailDesc": "By delivering timely, relevant messaging throughout the guest journey, Visa positioned itself as a trusted and convenient option for safe, seamless global travel.",
    "footnotes": "1. Brand lift study conducted only on web; 2. Someone who has traveled internationally more than 3x in the last year ; 3. % Change from pre-campaign (4/11/24-5/28/24) total bookings to during campaign total bookings (4/11/25-5/28/25), controlled for YoY growth in European bookings (4%)"
  },
  {
    "id": "united",
    "name": "UNITED",
    "title": "A global brand connected everywhere",
    "description": "United Airlines partnered with Marriott Media to highlight their vast global connectivity & feature key demand market.",
    "color": "#3baae3",
    "stats": [
      { "value": "+14.8", "unit": "PP", "desc": "In naming United as airline of choice" },
      { "value": "+10", "unit": "PP", "desc": "In perception that United is a leader in aviation" },
      { "value": "+6.4", "unit": "PP", "desc": "In aided brand awareness of United" },
      { "value": "+3.1", "unit": "PP", "desc": "In consideration intent of United" }
    ],
    "detailTitle": "Delivered a DESTINATION message within A GUESTS journey",
    "detailDesc": "By crafting destination-focused content for pivotal points in the guest travel journey, this campaign strengthened perceptions of United as an airline of choice and leader in aviation.",
    "footnotes": "1. Results for campaign across 4 weeks (5/8-6/6) for owned digital, on-property, and offsite digital (ran 5/22-6/6 only)"
  }
]
